import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

const scorecardsPage = PageBlueprint.make({
  params: {
    path: '/scorecards',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/Router').then(m => <m.Router />),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'scorecards',
  extensions: [scorecardsPage],
  routes: {
    root: rootRouteRef,
  },
});
export default plugin;
